import * as Yup from "yup";

export const NotificationValidations = () =>
  Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    message: Yup.string().trim().required("Message is required"),
    type: Yup.string().trim().required("Type is required"),
    target_type: Yup.string().trim().required("Target type is required"),
    target_ids: Yup.array()
    .of(Yup.string().trim())
    .when("type", {
      is: "targeted",
      then: (schema) => schema.min(1, "At least one option is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    status: Yup.string().trim().required("Status is required"),
    priority: Yup.string().trim().required("Priority is required"),
    platform: Yup.string().trim().required("Platform is required"),
  });
